module.exports = __webpack_public_path__ + "static/img_2273_optimized-cac7bdf9a06e26ba38ed038a2976b1aa.jpg";